import LogRocket from "logrocket";
import { applyMiddleware, createStore, compose } from "redux";
import { USE_MOCK_DATA } from "./constants";
// import debounce from "lodash/debounce"; // Cherry-pick method for smaller webpack bundle.
import throttle from "lodash/throttle"; // Cherry-pick method for smaller webpack bundle.
import { loadState, saveState } from "./StateLoader";
// import { applyMiddleware, createStore } from "redux";

// import logger from "redux-logger"; // This has been replaced by Redux Chrome extension
import thunk from "redux-thunk";
import promise from "redux-promise-middleware";

import reducers from "./reducers";

// const middleware = applyMiddleware(promise(), thunk, logger());

// export default createStore(
//   reducers,
//   middleware,
//   // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
// );
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducers,
  USE_MOCK_DATA
    ? {}
    : loadState() /* Preloaded state from localStorage to feed redux store */,
  // () => {}, /* Preloaded state from localStorage to feed redux store */
  composeEnhancers(
    // applyMiddleware(...middleware)
    applyMiddleware(promise(), thunk, LogRocket.reduxMiddleware())
  )
);

const saveToLocalStorage = () => {
  saveState(store.getState());
};
// var saveToLocalStorageDebounced = debounce(saveToLocalStorage, 300);
var saveToLocalStorageThrottled = throttle(saveToLocalStorage, 1000);
store.subscribe(() => {
  // Save state, throttled for performance (so it's not saving on every user input e.g. Typing redux-form input)
  saveToLocalStorageThrottled();
});
export default store;



// WEBPACK FOOTER //
// ./src/store.js